export const CURRENCY = Object.freeze({
  MYR: 'RM'
})
